import { InjectionToken } from '@angular/core';

export interface FormatConfiguration {
  currencies: {
    [id: number]: { id: number; name: string; code: string; symbol?: string };
  };
  statuses: {
    name: string;
    colour: string;
  }[];
  countries: {
    code: string;
    name: string;
  }[];
}

export const FORMATS_CONFIGURATION_TOKEN = new InjectionToken<
  FormatConfiguration
>(`Configure System Wide Formats`);
